/**
 * News items for /news and the home page "Latest news" strip.
 * `date` is "YYYY-MM" (omit for undated SPC updates). Items without `link` show an "SPC update" label.
 * Headlines are SPC's own wording; never use the full legal name.
 */

export const newsFilters = [
  { id: "all", label: "All" },
  { id: "licensing", label: "Licensing" },
  { id: "launches", label: "Launches" },
  { id: "partnerships", label: "Partnerships" },
  { id: "coming-soon", label: "Coming soon" },
];

const items = [
  {
    id: "caring-brands-expanded-licence",
    date: "2026-06",
    category: "licensing",
    headline: "Caring Brands and SPC sign expanded five-year licence for Photocil and Hair Enzyme Booster",
    summary:
      "The revised agreement extends SPC's rights beyond India to Latin America (Mexico, Brazil, Colombia, Ecuador, Peru, Dominican Republic, Trinidad and Tobago), Russia, Australia and New Zealand.",
    source: "Stock Titan",
    link: "https://stocktitan.net/news/CABR/caring-brands-inc-and-san-pellegrino-cosmetics-private-limited-a4wnsw4dd5tn.html",
    secondary: {
      label: "Also on Barchart",
      href: "https://www.barchart.com/story/news/2232906/caring-brands-inc-and-sanpellegrino-cosmetics-private-limited-announce-expanded-multi-territory-licensing-agreement-for-photocil-and-hair-enzyme-booster",
    },
  },
  {
    id: "world-vitiligo-day",
    date: "2026-06",
    category: "launches",
    headline: "SPC is Title Sponsor of World Vitiligo Day, featured on NDTV",
    summary: "SPC supported World Vitiligo Day, hosted in India this year, and launched the Photofirst Companion App for patients on home phototherapy.",
    source: "NDTV (YouTube)",
    link: "https://youtu.be/2E_F8b1iyb4?t=334",
    secondary: { label: "Visit the app", href: "https://photofirstcompanion.com" },
  },
  {
    id: "minoxiboost-india",
    date: "2023-07",
    category: "launches",
    headline: "MinoxiBoost launches in India through SPC",
    summary:
      "The minoxidil booster, which supports the follicle enzyme that activates minoxidil, launched in India under a distribution agreement covering 31 countries across Asia and the Middle East.",
    source: "TipRanks",
    link: "https://www.tipranks.com/news/press-releases/jupiter-wellness-and-sanpellegrino-cosmetics-announce-launch-of-cosmofix-minoxiboost-in-india-boosts-effectiveness-of-minoxidil-rogaine-for-hair-growth",
  },
  {
    id: "photofirst-launch",
    date: "2022-11",
    category: "launches",
    headline: "Photocil launches in India as Photofirst with Eris Oaknet",
    summary: "Launch meetings in Mumbai brought together more than 100 dermatologists, following CDSCO approval of the product.",
    source: "ACCESS Newswire",
    link: "https://www.accessnewswire.com/newsroom/en/healthcare-and-pharmaceutical/eris-oaknet-healthcare-and-cosmofix-technovation-announce-market-launc-726352",
  },
  {
    id: "photocil-approval",
    date: "2022-11",
    category: "licensing",
    headline: "Photocil approved for sale in India",
    summary: "India's CDSCO approved Photocil, the home phototherapy cream for vitiligo and psoriasis licensed to SPC.",
    source: "ACCESS Newswire",
    link: "https://www.accessnewswire.com/newsroom/en/banking-and-financial-services/jupiter-wellness-photocil-product-approved-for-sale-in-india-723513",
  },
  {
    id: "licence-31-countries",
    date: "2022-06",
    category: "licensing",
    headline: "SPC signs licence for Photocil and MinoxiBoost across 31 countries",
    summary:
      "The original distribution agreement covered India, the Philippines, Malaysia, Kuwait, Morocco, Saudi Arabia and other markets in Asia and the Middle East.",
    source: "ACCESS Newswire",
    link: "https://www.accessnewswire.com/newsroom/en/healthcare-and-pharmaceutical/jupiter-wellness-expands-distribution-in-asia-and-the-middle-east-with-706651",
  },
  {
    id: "sifi-zydus",
    date: "2019-05",
    category: "partnerships",
    headline: "SIFI and Zydus partner to bring advanced intraocular lenses to India",
    summary:
      "The Italian ophthalmology company and Zydus agreed to market innovative IOLs for cataract surgery in India, a partnership SPC brought together and continues to manage.",
    source: "BioSpectrum",
    link: "https://www.biospectrumasia.com/news/49/13358/sifi-zydus-to-launch-innovative-intraocular-lenses-in-india.html",
    secondary: { label: "Zydus press release", href: "https://www.zyduslife.com/public/pdf/pressrelease/Zydus_and_SIFI_from_Italy_announce_marketing_alliance.pdf" },
  },
  {
    id: "ofi-jv",
    category: "partnerships",
    headline: "SPC and OFI, Italy, form a joint venture to manufacture in India",
    summary:
      "The joint venture brings OFI's anti-ageing and whitening dermocosmetics, previously imported from Italy, into Indian manufacturing at a lower cost of goods.",
  },
  {
    id: "modi-zambon",
    category: "partnerships",
    headline: "Modi-Mundipharma and Zambon partnership",
    summary: "SPC facilitated a partnership between Modi-Mundipharma and Zambon for the Indian market.",
  },
  {
    id: "kedrion-india",
    category: "partnerships",
    headline: "Supporting Kedrion's India market access",
    summary: "SPC supported Kedrion, the Italian plasma-derived therapies company, with India market entry and access.",
  },
  {
    id: "tyrosinase-coming",
    category: "coming-soon",
    headline: "A novel tyrosinase inhibitor for hyperpigmentation is coming to India",
    summary:
      "SPC will be the authorised distributor in India of a patented, next-generation skin-brightening active ingredient, with an Indian manufacturing partner lined up for the first finished products.",
  },
  {
    id: "postbiotic-coming",
    category: "coming-soon",
    headline: "A clinically studied novel food ingredient for muscle health",
    summary: "SPC is bringing a patented postbiotic ingredient for muscle preservation to India, including as a companion to GLP-1 weight-loss therapy.",
  },
];

// Newest first; undated updates follow in the order listed.
export const newsItems = [...items].sort((a, b) => (b.date || "").localeCompare(a.date || ""));

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export const formatNewsDate = (d) => (d ? `${MONTHS[Number(d.slice(5, 7)) - 1]} ${d.slice(0, 4)}` : "");
export const newsCategoryLabel = (id) => newsFilters.find((f) => f.id === id)?.label ?? "";
